import { memo } from 'react'
import { InviteNewUserTable } from './components/inviteNewUserTable/inviteNewUserTable'
import { useProjectMemberEntryContext } from 'features/project/components/projectMemberEntryDialog/useProjectMemberEntryDialog'

export const InviteNewUserListPanel = memo(() => {
  const { selectedNewUsers } = useProjectMemberEntryContext()
  return <InviteNewUserTable selectedNewUsers={selectedNewUsers} />
})
